import * as React from 'react';
import { ListAgenciesFeature } from './listAgencies';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';

export const Agency:React.FC = () => (
  <React.Fragment>
    <HeaderFeature navBar />
    <ListAgenciesFeature />
    <FooterFeature isDisplay={true} />
  </React.Fragment>
);
